import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { LayoutTabSection as LayoutTab } from '../orders/_layouts/LayoutTabSection';

/**
 * 상세 화면 최상단 뒤로가기 헤더. 모니터링 GoodsDetailPanel 의 BackwardSection 과 동일 패턴.
 */
const DiagnosisDetailSticky = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBackward = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('select');
    navigate({ search: params.toString() });
  };

  return (
    <LayoutTab>
      <div
        onClick={handleBackward}
        className="flex cursor-pointer items-center gap-3 text-gr-900 Title2S24"
      >
        <ChevronLeft className="h-[32px] w-[32px]" />
        뒤로가기
      </div>
    </LayoutTab>
  );
};

export default DiagnosisDetailSticky;
